import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
//#region src/Avatar/index.tsx
/**
* Круглый аватар: фото, инициалы по центру или пустой плейсхолдер.
*/
const Avatar = ({ src, alt, initials, className }) => {
	const displayInitials = initials?.trim().slice(0, 2).toUpperCase();
	if (!src) return /* @__PURE__ */ jsx("div", {
		"aria-label": alt,
		role: "img",
		className: cn("bg-neutrals-90 paragraph-sm text-type-minor flex size-10 shrink-0 items-center justify-center rounded-full font-medium", className),
		children: displayInitials ? /* @__PURE__ */ jsx("span", {
			className: "max-w-full truncate px-0.5 text-center leading-none",
			children: displayInitials
		}) : null
	});
	return /* @__PURE__ */ jsx("img", {
		alt,
		className: cn("bg-neutrals-90 size-10 shrink-0 rounded-full object-cover", className),
		loading: "lazy",
		src
	});
};
//#endregion
export { Avatar };

//# sourceMappingURL=index.js.map